module.exports = __webpack_public_path__ + "img/facebook.c376d58a.png";